import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { useAuthStore } from '@/stores/auth'

import ShopLayout from '@/layouts/ShopLayout.vue'

NProgress.configure({ showSpinner: false })

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: ShopLayout,
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/home/TempHomeView.vue')
        },
        {
          path: 'products',
          name: 'products',
          component: () => import('@/views/product/ProductListView.vue')
        },
        {
          path: 'products/:productId',
          name: 'productDetail',
          component: () => import('@/views/product/ProductDetailView.vue')
        },
        {
          path: 'merchants',
          name: 'merchants',
          component: () => import('@/views/merchant/MerchantListView.vue')
        },
        {
          path: 'merchants/:merchantId',
          name: 'merchantDetail',
          component: () => import('@/views/merchant/MerchantDetailView.vue')
        },
        {
          path: 'login',
          name: 'login',
          component: () => import('@/views/auth/LoginView.vue'),
          meta: { public: true, hideNav: true }
        },
        {
          path: 'register',
          name: 'register',
          component: () => import('@/views/auth/RegisterView.vue'),
          meta: { public: true, hideNav: true }
        },
        {
          path: 'cart',
          name: 'cart',
          component: () => import('@/views/cart/CartView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'checkout',
          name: 'checkout',
          component: () => import('@/views/checkout/CheckoutView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'addresses',
          name: 'addresses',
          component: () => import('@/views/address/AddressListView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'addresses/new',
          name: 'addressNew',
          component: () => import('@/views/address/AddressEditView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'addresses/:addressId/edit',
          name: 'addressEdit',
          component: () => import('@/views/address/AddressEditView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'orders',
          name: 'orders',
          component: () => import('@/views/order/OrderListView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'orders/:orderId',
          name: 'orderDetail',
          component: () => import('@/views/order/OrderDetailView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'account',
          name: 'account',
          component: () => import('@/views/account/AccountHomeView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'account/password',
          name: 'changePassword',
          component: () => import('@/views/account/ChangePasswordView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'favorites',
          name: 'favorites',
          component: () => import('@/views/favorite/FavoriteListView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'follows',
          name: 'follows',
          component: () => import('@/views/follow/FollowListView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('@/views/feedback/FeedbackView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'complaint',
          name: 'complaint',
          component: () => import('@/views/complaint/ComplaintView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'merchant-apply',
          name: 'merchantApply',
          component: () => import('@/views/apply/MerchantApplyView.vue'),
          meta: { public: true }
        },
        {
          path: 'web3-tools',
          name: 'web3Tools',
          component: () => import('@/views/web3/Web3ToolsView.vue')
        }
      ]
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: () => import('@/views/error/NotFoundView.vue'),
      meta: { public: true }
    }
  ]
})

router.beforeEach((to) => {
  NProgress.start()
  const auth = useAuthStore()
  if (to.path === '/login' && auth.isAuthed) return { path: '/' }
  if (to.meta?.requiresAuth && !auth.isAuthed) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  return true
})

router.afterEach(() => {
  NProgress.done()
})

export default router
